export default {
  // component: ActivityLog,
  component: load(() =>
    import(/* webpackChunkName: "ActivityLog" */ "./Assignment")
  ),
  priority: 1,
  permissions: ["MapConsoleMenu/MapAssignmentMenu"],
  name: app.translate("انتساب کارگاه"),
  icon: "history",
  drawer: true,
  path: "assignment",
};
